import { Col, Empty, Row } from "antd"
import { ProfilePageData } from "libs/profile-repo"
import { dateFormat, getEnumLabel } from "libs/utils"
import ProfileAttachmentH5 from "./ProfileAttachmentH5"
import ProfileDetailItemH5 from "./ProfileDetailItemH5"

export default function ProfileAuthDetailH5({
  authDetail,
  enumState,
  qualificationEncoding,
}: ProfilePageData) {
  function buildRegisterValidDate() {
    const {
      registerValidFrom,
      registerValidTo,
      registerValidLongTerm,
    } = authDetail.auditFormDetail.mainInfo
    if (!registerValidFrom && !registerValidTo && !registerValidLongTerm) {
      return "暂无"
    } else {
      const from = registerValidFrom ? dateFormat(registerValidFrom) : "暂无"
      const to = registerValidLongTerm
        ? "长期"
        : registerValidTo
        ? dateFormat(registerValidTo)
        : "暂无"
      return `${from}至${to}`
    }
  }

  function getNameByCode(list, code) {
    let name = ""
    list.forEach((item) => {
      if (item.code === code) {
        name = item.name
        return name
      }
    })
    return name
  }

  function getNameByQualificationType(item) {
    const SupplierQualificationTypeEnum =
      enumState.SupplierQualificationTypeEnum
    let qualificationType = item.qualificationType
    let list = []
    if (qualificationType === SupplierQualificationTypeEnum?.LICENCE?.value) {
      list = qualificationEncoding.licenceList
    } else if (
      qualificationType ===
      SupplierQualificationTypeEnum?.SYSTEM_CERTIFICATION?.value
    ) {
      list = qualificationEncoding.systemCertificationList
    } else if (
      qualificationType === SupplierQualificationTypeEnum?.OTHERS?.value
    ) {
      return item.name
    }
    return getNameByCode(list, item.nameCode)
  }

  return (
    <div>
      <div className="card-wrap">
        <h3 className="title">企业信息</h3>
        <Row gutter={15}>
          <Col span={12}>
            <ProfileDetailItemH5 label="公司名称">
              {authDetail.auditFormDetail.mainInfo.name}
            </ProfileDetailItemH5>
          </Col>

          <Col span={12}>
            <ProfileDetailItemH5 label="统一社会信用代码">
              {authDetail.auditFormDetail.mainInfo.unifiedSocialCode}
            </ProfileDetailItemH5>
          </Col>
        </Row>
        <Row>
          <ProfileDetailItemH5 label="主营业务">
            {authDetail.supplierUser?.admittanceCategoryList
              ?.map((item) => item.name)
              ?.join("、")}
          </ProfileDetailItemH5>
        </Row>
        <Row gutter={15}>
          <Col span={12}>
            <ProfileDetailItemH5 label="企业类型">
              {getEnumLabel({
                enums: enumState.SupplierCompanyTypeEnum,
                value: authDetail.auditFormDetail.mainInfo.companyType,
              })}
            </ProfileDetailItemH5>
          </Col>
          <Col span={12}>
            <ProfileDetailItemH5 label="注册资本">
              {authDetail.auditFormDetail.mainInfo.registerFund}万元
            </ProfileDetailItemH5>
          </Col>
          <Col span={12}>
            <ProfileDetailItemH5 label="成立日期">
              {dateFormat(authDetail.auditFormDetail.mainInfo.registerDate)}
            </ProfileDetailItemH5>
          </Col>
          <Col span={12}>
            <ProfileDetailItemH5 label="营业期限">
              {buildRegisterValidDate()}
            </ProfileDetailItemH5>
          </Col>
          <Col span={12}>
            <ProfileDetailItemH5 label="法定代表人">
              {authDetail.auditFormDetail.mainInfo.legalManName}
            </ProfileDetailItemH5>
          </Col>
          <Col span={12}>
            <ProfileDetailItemH5 label="注册所在地">
              {authDetail.auditFormDetail.mainInfo.areaFullName}
            </ProfileDetailItemH5>
          </Col>
          <Col span={12}>
            <ProfileDetailItemH5 label="详细地址">
              {authDetail.auditFormDetail.mainInfo.contactAddress}
            </ProfileDetailItemH5>
          </Col>
          <Col span={12}>
            <ProfileDetailItemH5 label="营业执照">
              <ProfileAttachmentH5
                item={
                  authDetail.auditFormDetail.mainInfo?.registerCardAttachment
                }
              />
            </ProfileDetailItemH5>
          </Col>
        </Row>
      </div>
      <div className="card-wrap">
        <h3 className="title">资质文件</h3>
        <div>
          {authDetail.auditFormDetail?.qualificationFile
            ?.qualificationFileInfoList?.length ? (
            authDetail.auditFormDetail?.qualificationFile?.qualificationFileInfoList.map(
              (item, index) => (
                <div className="qualification-file" key={index}>
                  {item.qualificationType ===
                  enumState.SupplierQualificationTypeEnum
                    ?.INDUSTRY_QUALIFICATION.value ? (
                    <Row gutter={15}>
                      <Col span={12}>
                        <ProfileDetailItemH5 label="资质类型">
                          {getEnumLabel({
                            enums: enumState.SupplierQualificationTypeEnum,
                            value: item.qualificationType,
                          })}
                        </ProfileDetailItemH5>
                      </Col>
                      <Col span={12}>
                        <ProfileDetailItemH5 label="资质序列">
                          {getNameByCode(
                            qualificationEncoding.sequenceCodeList,
                            item.sequenceCode,
                          )}
                        </ProfileDetailItemH5>
                      </Col>
                      <Col span={12}>
                        <ProfileDetailItemH5 label="资质专业">
                          {getNameByCode(
                            qualificationEncoding.professionNameList,
                            item.professionCode,
                          )}
                        </ProfileDetailItemH5>
                      </Col>
                      <Col span={12}>
                        <ProfileDetailItemH5 label="资质等级">
                          {getEnumLabel({
                            enums: enumState.SupplierQualificationFileLevelEnum,
                            value: item.level,
                          })}
                        </ProfileDetailItemH5>
                      </Col>
                      <Col span={12}>
                        <ProfileDetailItemH5 label="资质文件">
                          {item.attachment.map((fileItem, fileIndex) => (
                            <ProfileAttachmentH5
                              key={fileIndex}
                              item={fileItem}
                            />
                          ))}
                        </ProfileDetailItemH5>
                      </Col>
                    </Row>
                  ) : (
                    <Row gutter={15}>
                      <Col span={12}>
                        <ProfileDetailItemH5 label="资质类型">
                          {getEnumLabel({
                            enums: enumState.SupplierQualificationTypeEnum,
                            value: item.qualificationType,
                          })}
                        </ProfileDetailItemH5>
                      </Col>
                      <Col span={12}>
                        <ProfileDetailItemH5 label="资质名称">
                          {getNameByQualificationType(item) || item.subName}
                        </ProfileDetailItemH5>
                      </Col>
                      <Col span={12}>
                        <ProfileDetailItemH5 label="资质文件">
                          {item.attachment.map((fileItem, fileIndex) => (
                            <ProfileAttachmentH5
                              key={fileIndex}
                              item={fileItem}
                            />
                          ))}
                        </ProfileDetailItemH5>
                      </Col>
                    </Row>
                  )}
                </div>
              ),
            )
          ) : (
            <div className="empty-wrap">
              <Empty />
            </div>
          )}
        </div>
      </div>
      <style jsx>{`
        .card-wrap {
          background: #ffffff;
          border-radius: 3px;
          padding: 14px 15px 1px 15px;
          margin-bottom: 10px;
          line-height: 1;
        }
        .title {
          font-size: 17px;
          color: #333333;
          margin: 0;
          margin-bottom: 20px;
        }
        .qualification-file {
          border-bottom: 1px solid #eee;
          padding-top: 20px;
        }
        .qualification-file:first-child {
          padding-top: 0;
        }
        .qualification-file:last-child {
          border: none;
        }
      `}</style>
    </div>
  )
}
